import { render, staticRenderFns } from "./ProjectEditTabSocial.vue?vue&type=template&id=42203ce4&"
import script from "./ProjectEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./ProjectEditTabSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports